/*
  Sail Workshop — kartın tamamını tıklanabilir yapar.
  CSS ile katman oynamak yerine tıklamayı ürün bağlantısına yönlendirir;
  böylece kart içindeki fiyat, rozet ve buton kendi işlevini korur.
*/
document.addEventListener('click', (event) => {
  const wrapper = event.target.closest('.card-wrapper');
  if (!wrapper) return;

  // Gerçek bir bağlantı, buton veya form öğesine tıklandıysa karışma
  if (event.target.closest('a, button, input, label, select, textarea, modal-opener, quick-add-bulk, .quick-add')) {
    return;
  }

  const link =
    wrapper.querySelector('.card__heading a[href]') ||
    wrapper.querySelector('a.full-unstyled-link[href]') ||
    wrapper.querySelector('a[href]');

  if (link) link.click();
});
